<template>
  <div class="h-box">
    <div class="box-logo">
      <el-carousel height="12.47rem">
        <el-carousel-item
          class="my-carousel-item"
          v-for="(item, index) in logoList"
          :key="index + 'logoList'"
        >
          <el-image :src="item.img" alt />
          <div v-if="item.txt" class="carousel-item-txt">{{ item.txt }}</div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="box-main">
      <div class="main-left">
        <div class="left-sec">
          <div class="sec-img">
            <el-image :src="home_2" />
          </div>
          <div class="sec-txt">
            <div class="txt-title">公司概况</div>
            {{ companyProfile }}
          </div>
        </div>
      </div>
      <div class="main-right">
        <div class="right-title">
          <!-- <div class="title-pot"></div> -->
          <div class="title_txt">行业动态</div>
          <el-image class="title_img" :src="home_hydt" />
        </div>
        <div class="right-content">
          <div
            class="content-con"
            v-for="(item, index) in newsList"
            :key="index + 'newsList'"
          >
            <a
              :href="item.type == 'pdf' || item.type == 'mp4' ? `/static/${item.type}/${item.txt}.${item.type}` : item.url"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div class="con-txt">
                {{ item.txt }}
              </div>
              <div class="con-context">{{ item.context }}</div>
              <div class="con-time">
                <div class="time-txt">{{ item.time }}</div>
                <div class="time-more">
                  MORE
                  <div class="more_img"></div>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="box-bottom">
      <div class="bottom-top">
        <div class="top-left">
          <div class="left-txt1">如果需要了解我们的服务，联系我们的团队</div>
          <div class="left-txt2">东风南方保险代理有限公司</div>
          <div class="left-txt3">
            ( 广州总部：广州市花都区风神大道11号之八二楼 )
          </div>
          <!-- <div class="left-txt4">
                    <div class="txt4-left">
                        <div>传真：020-36878670</div>
                        <div>QQ：12345678</div>
                    </div>
                    <div class="txt4-right">
                        <div>邮箱：12345678@qq.com</div>
                        <div>网址：https://www.dfsi.cn/</div>
                    </div>
                </div> -->
          <!-- <el-image class="left-img" :src="home_3" fit="contain" />
                <div class="left-content">
                    <div>如果需要了解我们的服务</div>
                    <div class="content-txt2">联系我们</div>
                    <div class="content-txt3">东风南方保险代理有限公司</div>
                    <div>广州总部：广州市花都区风神大道11号之八二楼</div>
                    <div>电话：020-36878670</div>
                    <div>传真：020-36878670</div>
                    <div>QQ：12345678</div>
                    <div>邮箱：12345678@qq.com</div>
                    <div>网址：<a href="https://www.dfsi.cn/" target="_blank" rel="noopener noreferrer">https://www.dfsi.cn/</a>
                    </div>
                </div> -->
        </div>
        <div class="top-middle">
          <!-- <el-image class="middle-img" :src="home_5" /> -->
          <div class="middle-phone">
            <el-image class="phone-img" :src="home_5ph" />
            <div class="phone-txt">
              <div class="txt-txt">联系客服</div>
              <div class="txt-num">020-36878670</div>
            </div>
          </div>
        </div>
        <div class="top-right">
          <div class="right-txt">我们的服务-遍布全国</div>
          <el-image class="right-img" :src="home_4" />
        </div>
      </div>
      <div class="bottom-box">
        <!-- <div class="box-txt"> -->
        东风南方保险代理有限公司 版权所有&nbsp;&nbsp;&nbsp;
        <a
          href="https://beian.miit.gov.cn/"
          target="_blank"
          rel="noopener noreferrer"
          >粤ICP备17109236号</a
        >
        <el-image class="txt-img" :src="home_6" />
        <a
          href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44011402000796"
          target="_blank"
          rel="noopener noreferrer"
          >粤公网安备440114020000796号</a
        >
        <!-- </div> -->
        <!-- <el-image class="box-box1" :src="home_5" />
            <div class="box-box2">
                <div class="box2-ga">
                    <div>东风南方保险代理有限公司 版权所有</div>
                </div>
                <div class="box2-ga">
                    <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">粤ICP备17109236号</a>
                    <div>&nbsp;&nbsp;|&nbsp;&nbsp;</div>
                    <el-image class="box-box4" :src="home_6" />
                    <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44011402000796" target="_blank" rel="noopener noreferrer">粤公网安备440114020000796号</a>
                </div>
            </div> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      logoList: [
        {
          img: require("../../assets/home_1.jpg"),
          txt: "专业   诚信   客户至上",
        },
        {
          img: require("../../assets/home1_2.jpg"),
          txt: "",
          // }, {
          //     img: require("../../assets/home1_3.jpg"),
          //     txt: ''
        },
      ],
      // home_2: require("../../assets/home_2.jpg"),
      home_2: require("../../assets/home_2s.jpg"),
      home_hydt: require("../../assets/home_hydt.png"),
      home_moreD: require("../../assets/home_moreD.png"),
      home_more: require("../../assets/home_more.png"),
      home_3: require("../../assets/home_3.png"),
      home_4: require("../../assets/home_4.png"),
      home_5: require("../../assets/home_5.jpg"),
      home_5ph: require("../../assets/home_5ph.png"),
      home_6: require("../../assets/police.png"),
      newsList: [
        {
          time: "2026-7-8",
          context:
            "信息来源：“广东保险”微信公众号",
          txt: "7·8 | “一朵小红花”保险知识公益答题活动今日上线",
          type: "url",
          url: "https://mp.weixin.qq.com/s/A3P8oCL_RX2MwJnT0zC2-w"
        },
        {
          time: "2026-7-8",
          context:
            "2026年“7.8全国保险公众宣传日丨”奋进“十五五”  保险让前行更有底气",
          txt: "2026年“7.8全国保险公众宣传日丨”奋进“十五五”  保险让前行更有底气",
          type: "pdf",
        },
        {
          time: "2025-7-14",
          context:
            "【7.8全国保险宣传日视频】东风南方保险代理有限公司——“爱和责任 保险让生活更美好”",
          txt: "【7.8全国保险宣传日视频】东风南方保险代理有限公司——“爱和责任 保险让生活更美好”",
          type: "url",
          url: "https://mp.weixin.qq.com/s/kOg-fbjjjRveL1wAc30qiQ"
        },
        {
          time: "2025-3-13",
          context:
            "保障金融权益+助力美好生活",
          txt: "保障金融权益助力美好生活",
          type: "pdf",
        },
        {
          time: "2025-3-13",
          context:
            "《金融反黑灰宝典》普通话版",
          txt: "《金融反黑灰宝典》普通话版",
          type: "mp4",
        },
        {
          time: "2025-3-13",
          context:
            "警惕“代理退保”陷阱，守好你的“保障防线”",
          txt: "警惕“代理退保”陷阱，守好你的“保障防线”",
          type: "mp4",
        },
        {
          time: "2025-3-13",
          context:
          "甄聪明的退保之路",
          txt: "甄聪明的退保之路",
          type: "mp4",
        },
        {
          time: "2025-3-13",
          context:
            "远离退保黑产 保护合法权益",
          txt: "远离退保黑产 保护合法权益",
          type: "mp4",
        },
        {
          time: "2025-1-15",
          context:
            "中国银行保险信息技术管理有限公司组织建设的专业、权威的金融产品查询平台于2024年10月31日正式面向消费者上线运行，为消费者提供简单、便利、快捷的金融产品信息查询服务。",
          txt: "一图读懂 金融保险产品查询平台",
          type: "url",
          url: "https://mp.weixin.qq.com/s/reoDbGC1KgFKlwM5l342jQ"
        },
        {
          time: "2024-09-29",
          context:
            "近年来，保险中介发挥专业、中立优势在帮助保险消费者厘清保险需求、买对保险产品和协助理赔等方面发挥了重要作用。",
          txt: "广东省保险中介行业协会关于警惕非法保险中介的提示函",
          type: "pdf",
        },
        {
          time: "2024-07-08",
          context:
            "【7.8保险宣传日视频】东风南方保险代理有限公司带你“一分钟了解保险三大属性”",
          txt: "【7.8保险宣传日视频】东风南方保险代理有限公司带你“一分钟了解保险三大属性”",
          type: "mp4",
        },
        {
          time: "2024-07-08",
          context:
            "【7.8保险宣传日】东风南方保险代理有限公司在行动——“保险让每一步前行更有底气”",
          txt: "【7.8保险宣传日】东风南方保险代理有限公司在行动——“保险让每一步前行更有底气”",
          type: "pdf",
        },
        {
          time: "2024-06-05",
          context:
            "尊敬的客户：为畅通保险消费者诉求渠道，及时协调处理消费者投诉事项，保护消费者合法权益，现将东风南方保险代理有限公司消费者接待日工作安排公告如下：",
          txt: "关于消费者接待日工作安排的公告",
          type: "pdf",
        },
        {
          time: "2024-04-24",
          context:
            "【金融知识宣传视频】东风南方保险代理有限公司——“《三国演义》新编之诸葛军师破解非法集资骗局”",
          txt: "【金融知识宣传视频】东风南方保险代理有限公司——“《三国演义》新编之诸葛军师破解非法集资骗局”",
          type: "mp4",
        },
        {
          time: "2024-04-24",
          context:
            "【金融知识宣传视频】东风南方保险代理有限公司——“《水浒传》新编之武大郎险掉“代理理赔”陷阱”",
          txt: "【金融知识宣传视频】东风南方保险代理有限公司——“《水浒传》新编之武大郎险掉“代理理赔”陷阱”",
          type: "mp4",
        },
        {
          time: "2024-04-24",
          context:
            "【金融知识宣传视频】东风南方保险代理有限公司——“西游记新编之ai诈骗现形记”",
          txt: "【金融知识宣传视频】东风南方保险代理有限公司——“西游记新编之ai诈骗现形记”",
          type: "mp4",
        },
        {
          time: "2024-04-24",
          context:
            "【金融知识宣传视频】东风南方保险代理有限公司——“刘姥姥进大观园 十二金钗说消保”",
          txt: "【金融知识宣传视频】东风南方保险代理有限公司——“刘姥姥进大观园 十二金钗说消保”",
          type: "mp4",
        },
        {
          time: "2024-03-14",
          context:
            "【金融消保宣传月】东风南方保险代理有限公司“金融消保在身边，保障权益防风险”",
          txt: "【金融消保宣传月】东风南方保险代理有限公司“金融消保在身边，保障权益防风险”",
          type: "pdf",
        },
        {
          time: "2024-03-14",
          context:
            "【金融消保宣传月】东风南方保险代理有限公司--“违规转贷要警惕！”",
          txt: "【金融消保宣传月】东风南方保险代理有限公司--“违规转贷要警惕！”",
          type: "mp4",
        },
        {
          time: "2024-03-14",
          context:
            "【金融消保宣传月】东风南方保险代理有限公司--“5.投资理财擦亮眼 防范非法集资诈骗新形态”",
          txt: "【金融消保宣传月】东风南方保险代理有限公司--“5.投资理财擦亮眼 防范非法集资诈骗新形态”",
          type: "mp4",
        },
        {
          time: "2024-03-14",
          context:
            "【金融消保宣传月】东风南方保险代理有限公司--“击退“代理黑产”维护客户合法权益”",
          txt: "【金融消保宣传月】东风南方保险代理有限公司--“击退“代理黑产”维护客户合法权益”",
          type: "mp4",
        },
        {
          time: "2023-09-25",
          context:
            "【金融消保宣传月】东风南方保险代理有限公司“汇聚金融力量 共创美好生活：本次活动以“汇聚金融力量 共创美好生活”为主题",
          txt: "【金融消保宣传月】东风南方保险代理有限公司“汇聚金融力量 共创美好生活”",
          type: "pdf",
        },
        {
          time: "2023-09-25",
          context:
            "【金融消保宣传月】东风南方保险代理有限公司“金融消费者权益保护教育宣传月”活动正式启动：为持续推动金融消费者教育工作",
          txt: "【金融消保宣传月】东风南方保险代理有限公司“金融消费者权益保护教育宣传月”活动正式启动",
          type: "pdf",
        },
        {
          time: "2023-07-08",
          context:
            "2023年7月8日是第11个“全国保险公众宣传日”。今年的年度主题为“保险力量，为奋斗的你加把劲”！",
          txt: "7·8全国保险公众宣传日丨保险力量，为奋斗的你加把劲",
          type: "pdf",
        },
        {
          time: "2023-06-15",
          context:
            "守住钱袋子 护好幸福家,2023年防范非法集资宣传月。什么是非法集资？即“未经国务院管理部门依法许可或者违反国家金融管理规定”",
          txt: "2023年防范非法集资宣传月活动｜守住钱袋子 护好幸福家",
          type: "pdf",
        },
        {
          time: "2023-03-19",
          context:
            "中国银行保险监督管理委员会令2022年第9号公布《银行保险机构消费者权益保护管理办法》(后简称《管理办法》)，自2023年3月1日起施行。该办法全面规范了机构的经营行为，进一步明确了行为监管的法制基础，与每一位费者息息相关，今天我们带您来了解一下该办法。",
          txt: "东风南方保险代理有限公司“3•15”教育宣传周｜图解《银行保险机构消费者权益保护管理办法》",
          type: "pdf",
        },
        {
          time: "2023-03-18",
          context:
            "伴随着我国城镇化进程的加速推进，新市民已成为城市发展中不可或缺的组成部分，也是接受金融服务的重要群体。了解、掌握必要的金融知识，不仅可以帮助新市民群体在城市中扎稳脚跟，更能解决新市民群体安居乐业的后顾之忧",
          txt: "东风南方保险代理有限公司“3•15”教育宣传周｜情系新市民，守护伴身旁",
          type: "pdf",
        },
        {
          time: "2023-03-17",
          context:
            "青少年思维活跃，容易接受新鲜事物，好奇心强，容易被广告引导盲目从众消费。在现实生活中，青少年消费群体随着年龄段的不同有着不同的消费状态，但也存在共性。一是青少年消费中普遍存在形式合理性和实质非理性，",
          txt: "东风南方保险代理有限公司“3•15”教育宣传周｜呵护成长，消保在行动",
          type: "pdf",
        },
        {
          time: "2023-03-16",
          context:
            "近年来，越来越多的不法分子将”魔爪”伸向了金融知识欠缺、防骗意识薄弱的老年群体，通过层出不穷的诈骗手段，诱导老年人落入陷阱，严重侵害老年人的财产安全，将老年人辛苦积攒一生的积蓄”骗”为己有。",
          txt: "东风南方保险代理有限公司“3•15”教育宣传周｜老年人如何防范金融风险？",
          type: "pdf",
        },
        {
          time: "2023-03-15",
          context:
            "购买保险需注意什么？选择符合自身需要的寿险产品。根据自身需要和财力大小，以不给个人和家庭带来过重的经济压力，并且能满足保障需求为标准，选择适合自己的险种。保费支出不超过家庭年收入的20%为佳。",
          txt: "东风南方保险代理有限公司“3•15”教育宣传周｜购买保险需注意",
          type: "pdf",
        },
        {
          time: "2023-03-14",
          context:
            "2015年11月13日，国务院办公厅发布了《关于加强金融消费者权益保护工作的指导意见》，明确了金融机构消费者权益保护工作的行为规范，要求金融机构充分尊重并自觉保障金融消费者的财产安全权、",
          txt: "东风南方保险代理有限公司“3•15”教育宣传周｜金融消费者权益保护知识",
          type: "pdf",
        },
        {
          time: "2023-03-13",
          context:
            "一年一度的消费者权益日来了，什么是金消费者权益？金融消费者权益有几个？您都知道吗？接下来跟着小编的步伐一起来了解",
          txt: "东风南方保险代理有限公司“3•15”教育宣传周｜金融消费者权益知多少",
          type: "pdf",
        },
        {
          time: "2022-11-26",
          context:
            "近期，有消费者反映，某些保险销售人员为提高销售业绩，在保险产品销售过程中，向消费者提供与实际不符或让人误解的信息，诱导消费者购买保险产品，存在套路营销、诱导消费、强制搭售等问题，侵害了消费者合法权益",
          txt: "关于防范保险销售误导的风险提示",
          type: "pdf",
        },
        {
          time: "2022-11-22",
          context:
            "7 月 29 日，全国专项办召开全国打击整治养老诈骗专项行动第 2 次推进会，分析总结前一阶段专项行动推进情况，研究部署下一阶段工作",
          txt: "全国打击整治养老诈骗专项行动第二次推进会召开",
          type: "pdf",
        },
        {
          time: "2022-10-18",
          context:
            "为深入贯彻落实国务院《广州南沙深化面向世界的粤港澳全面合作总体方案》（以下简称《南沙方案》），引领金融业大力支持南沙粤港澳重大合作平台建设，2022 年 9 月 15 日下午，广东银保监局在南沙召开座谈会，围绕促进粤港澳金融市场互联互通、建设高水平开放门户、加强金融规则衔接和机制对接等听取银行保险机构意见建议",
          txt: "推进南沙金融改革创新，深化粤港澳全面合作——广东银保监局在南沙召开金融支持南沙深化面向世界的粤港澳全面合作座谈会",
          type: "pdf",
        },
        {
          time: "2022-10-10",
          context:
            "7 月 8 日，中国银保监会系统召开推进自贸试验区建设（电视电话）专题会议，总结银行业保险业支持自贸试验区建设情况，研究部署下一步工作。银保监会党委委员、副主席梁涛出席会议并讲话。",
          txt: "银保监会召开推进自贸试验区建设专题会议",
          type: "pdf",
        },
        {
          time: "2022-08-02",
          context:
            "为坚决抵制“退保黑产”和深入解决“销售误导”等行业痼疾，加强保险销售从业人员的自律管理，中国保险行业协会正在编制《保险销售从业人员执业失信行为认定指引》，以便更好地保障保险消费者合法权益，现向全体委员单位发出如下倡议",
          txt: "中国保险行业协会保险中介专业委员会关于坚决抵制退保黑产和销售误导 全力维护保险消费者权益的倡议书",
          type: "pdf",
        },
        {
          time: "2022-05-29",
          context:
            "近期，由党史学习教育领导小组办公室组织编写的《百年初心成大道——党史学习教育案例选编》一书，面向全党全社会公开出版发行。中国银保监会专门印发通知，要求系统各级党组织将该书作为党史学习教育常态化长效化的重要辅导读物，采取多种形式做好学习使用工作，巩固拓展党史学习教育成果，推动监管中心工作高质量发展，以实际行动迎接党的二十大胜利召开。",
          txt: "中国银保监会“我为群众办实事”实践活动案例入选《百年初心成大道——党史学习教育案例选编》",
          type: "pdf",
        },
      ],
      companyProfile:
        "东风南方保险代理有限公司成立于2016年3月30日，总部位于广州，法定代表人袁杰，是一家专注于汽车保险的全国性专业保险代理机构，在全国已开设19家分支机构。公司秉承“拥抱客户，协力合作”的信念，与人保、平安、太保、国寿财、大地、阳光、中华联合、太平财险等多家保险公司开展深度合作，致力于打造为“综合性、全方位的保险代理服务商”，为广大客户提供最优质的保险代理服务 。",
    };
  },
  methods: {
    changeFiles() {},
  },
};
</script>

<style lang="less" scoped>
::-webkit-scrollbar-track-piece {
  //滚动条凹槽的颜色，还可以设置边框属性
  background-color: #f8f8f8;
}

::-webkit-scrollbar {
  //滚动条的宽度
  width: 9px;
  height: 9px;
}

::-webkit-scrollbar-thumb {
  //滚动条的设置
  background-color: #dddddd;
  background-clip: padding-box;
  min-height: 28px;
}

::-webkit-scrollbar-thumb:hover {
  background-color: #bbb;
}

.h-box {
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 100%;
  text-align: left;

  .box-logo {
    width: 100%;
    height: 12.47rem;
    max-width: 1920px;

    .my-carousel-item {
      // position: relative;

      .el-image {
        width: 100%;
        height: 12.47rem;
        max-width: 1920px;
      }
    }
    .el-carousel__item:nth-child(2n + 1) {
      .carousel-item-txt {
        width: 17.33rem;
        height: 2.81rem;
        background: rgba(0, 0, 0, 0.25);
        padding: 0.33rem 2.3rem;
        color: #ededed;
        font-size: 2rem;
        position: absolute;
        bottom: 0.87rem;
        left: 10.77rem;
      }
    }
  }

  .box-main {
    display: flex;
    flex-direction: row;
    // align-items: center;
    justify-content: center;
    max-width: 1920px;
    // width: 100%;
    margin: 2.07rem 3.23rem 78px;

    .main-left {
      display: flex;
      flex-direction: column;
      width: 32.7rem;
      height: 16.2rem;
      background: url("../../assets/home_2bg.jpg") no-repeat center;
      background-size: contain;

      .left-sec {
        width: 100%;
        display: flex;
        flex-direction: row;
        margin: 1.8rem 0.77rem;

        .sec-img {
          // border: 1.5px dashed #ccc;

          .el-image {
            width: 14.17rem;
            height: 12.93rem;
          }
        }

        .sec-txt {
          width: 12.93rem;
          margin-left: 1.4rem;
          padding: 0.7rem 0.93rem;
          line-height: 0.93rem;
          background-color: #fff;
          font-size: 0.53rem;
          color: #666666;
          box-shadow: 0 0.03rem 0.47rem 0 #c5c5c5;

          .txt-title {
            font-size: 1rem;
            margin-bottom: 0.7rem;
            padding-bottom: 0.43rem;
            font-weight: bold;
            color: #333333;
            border-bottom: 1px solid #c9c9c9;
          }
        }
      }
    }

    .main-right {
      // width: 40%;
      margin-left: 3.6rem;

      .right-title {
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-bottom: 7px;
        position: relative;
        margin-top: 2.34rem;

        .txt_img {
          border: 1px dashed #ccc;
          width: 11.4rem;
          height: 1.83rem;
        }

        .title_txt {
          position: absolute;
          font-size: 1.47rem;
          top: -0.67rem;
          font-weight: bold;
          color: #333333;
        }
      }

      .right-content {
        height: 11.5rem;
        width: 19.67rem;
        overflow-y: auto;

        .content-con {
          background-color: #fff;
          padding: 0px 0.7rem;
          margin: 0.47rem 0;
          border-bottom: 0.13rem solid transparent;
          cursor: pointer;
          box-shadow: 0 0.1rem 0.33rem 0 #cccccc;

          a {
            text-decoration: none;
            color: #2c3e50;
          }

          .con-txt {
            font-size: 0.67rem;
            padding: 0.47rem 0px 10px;
            font-weight: bold;
            // a:hover {
            //     color: #0476c3;
            // }
          }

          .con-context {
            font-size: 0.47rem;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          .con-time {
            font-size: 0.53rem;
            padding: 0.23rem 0 0.43rem;
            color: #888888;
            display: flex;
            flex-direction: row;
            justify-content: space-between;

            .time-more {
              display: flex;
              flex-direction: row;
              align-items: center;

              .more_img {
                margin-left: 0.13rem;
                width: 0.4rem;
                height: 0.4rem;
                background: url("../../assets/home_moreD.png") no-repeat;
                background-size: cover;
              }
            }
          }
        }

        .content-con:hover a .con-txt,
        .content-con:hover a .con-time .time-more {
          color: #ff9600;
        }

        .content-con:hover a .con-time .time-more .more_img {
          background: url("../../assets/home_more.png") no-repeat;
          background-size: cover;
        }

        .content-con:hover {
          border-bottom: 0.13rem solid #ff9600;
        }
      }
    }
  }

  .box-bottom {
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 15.67rem;
    width: 100%;
    max-width: 1920px;
    margin-top: 2.6rem;
    // padding: 0;
    background: url("../../assets/home_bottom.jpg") no-repeat center;
    // background-blend-mode: multiply;
    background-size: cover;

    .bottom-top {
      display: flex;
      flex-direction: row;
      align-items: center;
      // justify-content: space-around;
      // width: 100%;
      height: 14.27rem;
      margin-top: 2.17rem;

      .top-left {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        color: #ffffff;
        width: 16rem;
        margin-left: 2.63rem;

        .left-txt1 {
          font-size: 0.8rem;
        }

        .left-txt2 {
          margin-top: 0.4rem;
          font-size: 1.33rem;
        }

        .left-txt3 {
          margin-top: 0.27rem;
          font-size: 0.6rem;
        }

        .left-txt4 {
          display: flex;
          flex-direction: row;
          margin-top: 1.5rem;
          font-size: 0.47rem;
          line-height: 0.9rem;

          .txt4-right {
            margin-left: 2.2rem;
          }
        }

        .left-img {
          margin-right: 1rem;
          height: 6.3rem;
          // margin: 0px 40px;
        }

        .left-content {
          display: flex;
          flex-direction: column;
          justify-content: center;
          margin-left: 1rem;
          // align-items: center;
          color: white;

          a {
            text-decoration: none;
            color: white;
          }

          a:hover {
            color: #0476c3;
          }

          .content-txt2 {
            font-size: 30px;
            margin: 5px 0px;
          }

          .content-txt3 {
            margin: 7px 0px;
            font-weight: bold;
          }
        }
      }

      .top-middle {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin-left: 1.6rem;

        .middle-img {
          width: 3.33rem;
          height: 3.33rem;
        }

        .middle-phone {
          display: flex;
          flex-direction: row;
          // margin-top: 1.2rem;

          .phone-img {
            width: 1.9rem;
            height: 1.9rem;
          }

          .phone-txt {
            display: flex;
            flex-direction: column;
            justify-content: center;
            margin-left: 0.63rem;
            color: #ffffff;
            font-size: 0.63rem;

            .txt-num {
              font-size: 0.93rem;
            }
          }
        }

        // height: 250px;
        // width: 1px;
        // margin: 20px;
        // background-color: #8c8e90;
      }

      .top-right {
        display: flex;
        flex-direction: column;
        color: #ffffff;
        font-size: 0.8rem;
        margin-left: 6.3rem;

        .right-img {
          width: 12.3rem;
          height: 10.17rem;
        }
      }
    }

    .bottom-box {
      color: #d9d9d9;
      font-size: 0.47rem;
      // margin: .43rem 4.27rem 0rem 9.7rem;
      margin-left: 9.7rem;
      padding: 0.37rem 0.4rem;
      width: 50.03rem;
      border-top: 0.03rem solid #727272;
      display: flex;
      flex-direction: row;
      align-items: center;

      .txt-img {
        width: 0.57rem;
        height: 0.57rem;
        margin: 0 0.13rem 0 0.3rem;
      }

      a {
        color: #d9d9d9;
        text-decoration: none;
      }

      a:hover {
        color: #ff9600;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/Home/index.vue